var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"question-content"},[[_vm._m(0)]],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframe",staticClass:"ifa",staticStyle:{"width":"100%","height":"100vh"},attrs:{"name":"child","id":"child","src":_vm.url,"frameborder":"0","scrolling":"no"}})
}]

export { render, staticRenderFns }